import type {
	Configuration,
	PopupRequest,
	RedirectRequest,
} from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";

import { environmentConfig } from "~/shared/utils/environment-config.ts";
import { getBaseUrl } from "~/shared/utils/get-base-url.ts";

const authConfig: Configuration = {
	auth: {
		authority:
			// comes from App Reg, using Tenant ID
			"https://login.microsoftonline.com/c4dde173-b56e-463d-a6e0-0983142ad7ed",
		clientId: environmentConfig.msalClientId,
		redirectUri: `${globalThis.location.origin}${getBaseUrl()}/auth-callback`,
		postLogoutRedirectUri: `${globalThis.location.origin}${getBaseUrl()}`,
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false,
	},
};

const b2cAuthConfig: Configuration = {
	auth: {
		authority: environmentConfig.b2cAuthority, // comes from App Reg, using B2C Tenant ID and policy
		clientId: environmentConfig.traxB2CClientId,
		redirectUri: `${globalThis.location.origin}${getBaseUrl()}/authcallback`,
		postLogoutRedirectUri: `${globalThis.location.origin}${getBaseUrl()}`,
		knownAuthorities: environmentConfig.b2cAuthority
			? [new URL(environmentConfig.b2cAuthority).hostname]
			: [],
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false,
	},
	system: {
		// allowRedirectInIframe: true,
		iframeHashTimeout: 6000,
		loggerOptions: {
			loggerCallback: () => {},
			logLevel: 3,
		},
	},
};

export const b2cMsalInstance = new PublicClientApplication(b2cAuthConfig);

export const msalInstance = new PublicClientApplication(authConfig);

type LoginRequest = PopupRequest | RedirectRequest; // Login could be either

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, see [OpenID Connect scopes][1].
 *
 * [1]: https://learn.microsoft.com/en-us/entra/identity-platform/scopes-oidc#openid-connect-scopes
 */
export const loginRequest: LoginRequest = {
	scopes: ["openid", "offline_access"],
};
export const b2cLoginRequest: LoginRequest = {
	// scopes: [
	// 	"openid",
	// 	"offline_access",
	// 	"TraxWebApplicationLayer.DefaultUserPermission",
	// ],
	scopes: ["openid", "offline_access"],
};

// API token request with proper B2C scopes from environment config
export const b2cApiTokenRequest: LoginRequest = {
	scopes: environmentConfig.services.ltlQuoting.scopes,
};

/** sessionStorage key used to persist the intended URL across the B2C login redirect. */
export const POST_AUTHENTICATED_USER = "afterUserAuthenticated";
